import { render } from "./Accounting.vue?vue&type=template&id=70c861e2&scoped=true&ts=true&lang=pug"
import script from "./Accounting.vue?vue&type=script&lang=ts"
export * from "./Accounting.vue?vue&type=script&lang=ts"

import "./Accounting.vue?vue&type=style&index=0&id=70c861e2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c861e2"]])

export default __exports__